<template>
  <v-dialog width="100%" max-width="600px" persistent v-model="show">
    <v-card>
      <v-card-title
        >{{ title }} <v-spacer />
        <v-btn icon flat @click="closeDialog"><v-icon icon="$close" /></v-btn>
      </v-card-title>
      <v-card-text>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-checkbox
                label="Новая категория"
                v-model="isAddNewCategory"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="isAddNewCategory">
            <v-col cols="12">
              <v-text-field
                label="Наименование категории"
                v-model="newCategoryName"
                :rules="[rules.nameRequired]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-show="showSelectCategories">
            <v-col cols="12"
              ><v-autocomplete
                :items="allCategories"
                v-model="selectedCategory"
                item-title="text"
                placeholder="Выберите категорию"
                :rules="[rules.categoryRequired]"
              >
              </v-autocomplete
            ></v-col>
          </v-row>
          <v-row>
            <v-spacer />
            <v-col cols="3"
              ><v-btn block @click="saveCategoryRelation" color="primary"
                >Сохранить</v-btn
              ></v-col
            >
            <v-col cols="3"
              ><v-btn block @click="closeDialog">Отмена</v-btn></v-col
            >
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0"> </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const CategoryRepository = RepositoryFactory.get("category");
const SupplierCategoryRepository = RepositoryFactory.get("supplierCategory");
const SubcategoryRepository = RepositoryFactory.get("subCategory");

export default {
  data() {
    return {
      show: false,
      title: "Создание связи с категорией каталога",
      valid: true,
      supplierCategoryId: null,
      allCategories: [],
      relatedCategory: {},
      isCreateNewCategory: false,
      selectedCategory: null,
      loading: false,
      isAddNewCategory: false,
      newCategoryName: null,
      rules: {
        nameRequired: (value) =>
          (!!value && this.isAddNewCategory) || "Обязательно к заполнение",
        categoryRequired: (value) =>
          (!!value && this.showSelectCategories) ||
          "Необходимо выбрать категорию",
      },
    };
  },
  watch: {
    isAddNewCategory() {
      this.clearSelectedCategory();
      if (this.isAddNewCategory) {
        if (!this.supplierCategory.isMainCategory) {
          this.getCategoriesForSelect();
        }
      } else {
        if (this.supplierCategory.isMainCategory) {
          this.getCategoriesForSelect();
        } else {
          this.getSubcategoriesForSelect();
        }
      }
    },
  },
  methods: {
    async openDialog(supplierCategory) {
      this.clearSelectedCategory();
      this.loading = true;
      if (supplierCategory.isMainCategory) {
        await this.getCategoriesForSelect();
      } else {
        await this.getSubcategoriesForSelect();
      }

      this.supplierCategory = supplierCategory;
      this.show = true;
      const category = await SupplierCategoryRepository.getSupplierCategory(
        this.supplierCategory.id
      );
      if (category && category.data.status === "success") {
        this.selectedCategory = this.allCategories.find(
          (x) => x.value == category.data.data.categoryId
        );
      }
      this.loading = false;
    },
    closeDialog() {
      this.show = false;
      this.selectedCategory = null;
      this.isAddNewCategory = false;
      this.allCategories = [];
    },
    async getCategoriesForSelect() {
      const result = await CategoryRepository.getCategoriesForSelect();
      if (result) {
        if (result.data.status === "success") {
          this.allCategories = result.data.data;
        }
      }
    },
    async getSubcategoriesForSelect() {
      const result = await SubcategoryRepository.getCategoriesForSelect();
      if (result) {
        if (result.data.status === "success") {
          this.allCategories = result.data.data;
        }
      }
    },
    async saveCategoryRelation() {
      this.$refs.form.validate();
      if (this.valid) {
        if (this.isAddNewCategory) {
          this.addNewCategory();
        } else {
          const categoryId = this.selectedCategory.value
            ? this.selectedCategory.value
            : this.selectedCategory;
          let categoryRelation = {
            categoryId: categoryId,
            supplierCategoryId: this.supplierCategory.id,
            isMainCategory: this.supplierCategory.isMainCategory,
          };
          const result = await SupplierCategoryRepository.saveCategoryRelation(
            categoryRelation
          );
          if (result && result.data.status === "success") {
            this.closeDialog();
            this.$emit("update");
          }
        }
      }
    },
    async addNewCategory() {
      const categoryId =
        this.selectedCategory && this.selectedCategory.value
          ? this.selectedCategory.value
          : this.selectedCategory;
      const newCategory = {
        name: this.newCategoryName,
        supplierCategoryId: this.supplierCategory.id,
        parentCategoryId: categoryId,
      };
      const result = await SupplierCategoryRepository.addNewCategory(
        newCategory
      );
      if (result && result.data.status === "success") {
        this.$emit("update");
        this.closeDialog();
      }
    },
    clearSelectedCategory() {
      this.selectedCategory = null;
    },
  },
  computed: {
    showSelectCategories: {
      get() {
        return (
          !this.isAddNewCategory ||
          (this.supplierCategory && !this.supplierCategory.isMainCategory)
        );
      },
    },
  },
};
</script>
<style scoped>
.v-card-title {
  padding: 0 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: center !important;
}
</style>
